<form [formGroup]="form" autocomplete="off">
    <ng-container [formArrayName]="formArraySelector">
        <ng-container *ngFor="let controls of (formArrayObservable | async); let i = index;" [formGroupName]="i">
            <ng-container *ngFor="let control of controls; trackBy: trackByName">
                <ng-container *ngIf="!control.hidden">
                    <div [ngSwitch]="control.componentType">
                        <app-select
                            *ngSwitchCase="componentTypes.Select"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-select>
                        <app-radio-group
                            *ngSwitchCase="componentTypes.RadioGroup"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-radio-group>
                        <app-autocomplete
                            *ngSwitchCase="componentTypes.Autocomplete"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-autocomplete>
                        <app-phone-autocomplete
                            *ngSwitchCase="componentTypes.PhoneAutocomplete"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-phone-autocomplete>
                        <app-datepicker
                            *ngSwitchCase="componentTypes.Datepicker"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-datepicker>
                        <app-country-autocomplete
                            *ngSwitchCase="componentTypes.CountryAutocomplete"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-country-autocomplete>
                        <app-lockable-datepicker
                            *ngSwitchCase="componentTypes.LockableDatepicker"
                            [formControlName]="control.name"
                            [control]="control"
                            [leftAligned]="true"
                        ></app-lockable-datepicker>
                        <app-password-input
                            *ngSwitchCase="componentTypes.Password"
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-password-input>
                        <app-panel-input
                            *ngSwitchDefault
                            [formControlName]="control.name"
                            [control]="control"
                        ></app-panel-input>
                    </div>

                    <div *ngIf="!hiddenActions" class="text-center">
                        <button type="submit" class="btn btn-sm btn-primary mr-3">Submit</button>
                        <a href="javascript:void('0');" id="edit-cancel">Clear</a>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</form>
